import React from 'react';
import styles from './ReadingTime.module.scss';

interface ReadingTimeProps {
  time: string;
}

const ReadingTime = ({ time }: ReadingTimeProps) => {
  return (
    <div className={styles['reading-time']}>
      <div className={styles['reading-time__icon']}>
        <div className={`iconSprites iconSprites-book`} />
      </div>
      <div className={styles['reading-time__time']}>{time}</div>
    </div>
  );
};

export default ReadingTime;
